export const siteConfig = {
  name: '吃瓜黑料网',
  tagline: '吃瓜不打烊，黑料不停更',
  description: '每日更新网红黑料、明星塌房、热门事件，提供在线爆料与视频，实时追踪每日大赛',
};

export const navLinks = [
  { label: '首页', href: '/' },
  { label: '网红黑料', href: '/category/wanghong' },
  { label: '明星塌房', href: '/category/mingxing' },
  { label: '每日大赛', href: '/category/dasai' },
  { label: '吃瓜视频', href: '/category/video' },
  { label: '关于我们', href: '/about' },
];

export const heroArticles = [
  {
    id: 1,
    title: '知名网红直播间翻车，私下聊天记录遭曝光，人设彻底崩塌',
    excerpt: '曾经拥有千万粉丝的顶流网红，在近日一场直播中意外翻车，随后大量私下聊天记录被知情人曝光，内容令人瞠目结舌。',
    category: '网红黑料',
    categorySlug: 'wanghong',
    date: '2026-07-06',
    image: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20atmosphere%20with%20silhouette%20of%20a%20person%20on%20a%20dimly%20lit%20stage%2C%20dramatic%20lighting%2C%20cinematic%20mood%2C%20dark%20background%20with%20subtle%20warm%20tones%2C%20editorial%20photography%20style%2C%20high%20contrast%2C%20mysterious%20and%20tense%20vibe&width=800&height=500&seq=hero-article-01&orientation=landscape',
    slug: 'zhiming-wanghong-zhibo-fanche',
  },
  {
    id: 2,
    title: '顶流男星深夜密会神秘女子，酒店同框照流出，粉丝集体破防',
    excerpt: '某顶流男星被拍到深夜与一名神秘女子共同进入高端酒店，两人举止亲密，照片一经曝光立即引发全网热议。',
    category: '明星塌房',
    categorySlug: 'mingxing',
    date: '2026-07-05',
    image: 'https://readdy.ai/api/search-image?query=Luxury%20hotel%20entrance%20at%20night%20with%20warm%20ambient%20lighting%2C%20two%20silhouetted%20figures%20walking%20in%2C%20paparazzi%20style%20photography%2C%20dramatic%20atmosphere%2C%20mysterious%20mood%2C%20dark%20background%20with%20golden%20accents&width=800&height=500&seq=hero-article-02&orientation=landscape',
    slug: 'dingliu-nanxing-shenye-mihui',
  },
  {
    id: 3,
    title: '选秀冠军被爆学历造假，昔日采访言论被扒，人设彻底翻车',
    excerpt: '近日有网友深扒某选秀节目冠军的背景资料，发现其声称的名校学历存在严重造假嫌疑，多段早期采访视频中的言论也前后矛盾。',
    category: '网红黑料',
    categorySlug: 'wanghong',
    date: '2026-07-04',
    image: 'https://readdy.ai/api/search-image?query=Graduation%20cap%20and%20diploma%20on%20dark%20surface%20with%20dramatic%20shadow%20lighting%2C%20mysterious%20atmosphere%2C%20cinematic%20noir%20style%2C%20dark%20background%20with%20subtle%20warm%20glow%2C%20tense%20editorial%20mood&width=800&height=500&seq=hero-article-03&orientation=landscape',
    slug: 'xuanxiu-guanjun-xueli-zaojia',
  },
];

export const hotArticles = [
  {
    id: 4,
    title: '知名美食博主被曝使用过期食材，粉丝怒斥欺骗消费者',
    category: '网红黑料',
    categorySlug: 'wanghong',
    date: '2026-07-07',
    image: 'https://readdy.ai/api/search-image?query=Dark%20kitchen%20scene%20with%20dramatic%20lighting%2C%20spoiled%20food%20on%20counter%2C%20mysterious%20investigative%20mood%2C%20cinematic%20noir%20style%2C%20warm%20dark%20tones%2C%20tense%20atmosphere%2C%20editorial%20photography&width=600&height=400&seq=hot-article-01&orientation=landscape',
    slug: 'meishi-bozhu-guoqi-shicai',
  },
  {
    id: 5,
    title: '某女星与前经纪公司解约内幕曝光，违约金数额惊人',
    category: '明星塌房',
    categorySlug: 'mingxing',
    date: '2026-07-06',
    image: 'https://readdy.ai/api/search-image?query=Legal%20documents%20and%20contracts%20on%20dark%20wooden%20desk%2C%20dramatic%20lighting%20from%20side%2C%20mysterious%20business%20atmosphere%2C%20cinematic%20noir%2C%20dark%20background%2C%20warm%20amber%20glow&width=600&height=400&seq=hot-article-02&orientation=landscape',
    slug: 'nvxing-jingji-gongsi-jiuyue',
  },
  {
    id: 6,
    title: '情侣网红分手互撕，双方各执一词爆出大量猛料',
    category: '网红黑料',
    categorySlug: 'wanghong',
    date: '2026-07-05',
    image: 'https://readdy.ai/api/search-image?query=Broken%20heart%20symbolism%20on%20dark%20background%2C%20dramatic%20lighting%2C%20two%20silhouetted%20figures%20facing%20away%2C%20cinematic%20mood%2C%20dark%20atmosphere%20with%20warm%20accents%2C%20emotional%20tension&width=600&height=400&seq=hot-article-03&orientation=landscape',
    slug: 'qinglv-wanghong-fenshou-husi',
  },
];

export const videoArticles = [
  {
    id: 7,
    title: '实拍：某网红活动现场被粉丝当众质问黑历史',
    category: '吃瓜视频',
    categorySlug: 'video',
    date: '2026-07-06',
    image: 'https://readdy.ai/api/search-image?query=Crowd%20scene%20at%20public%20event%20with%20dramatic%20spotlight%2C%20confrontation%20mood%2C%20dark%20background%2C%20cinematic%20documentary%20style%2C%20warm%20tones%2C%20tense%20atmosphere&width=600&height=400&seq=video-01&orientation=landscape',
    slug: 'wanghong-huodong-bei-zhiwen',
  },
  {
    id: 8,
    title: '偷拍：某男团成员深夜酒吧与多名异性亲密互动',
    category: '吃瓜视频',
    categorySlug: 'video',
    date: '2026-07-05',
    image: 'https://readdy.ai/api/search-image?query=Nightclub%20interior%20with%20neon%20lights%20and%20dramatic%20shadows%2C%20crowded%20dance%20floor%2C%20mysterious%20vibe%2C%20dark%20atmosphere%20with%20warm%20accent%20lighting%2C%20cinematic&width=600&height=400&seq=video-02&orientation=landscape',
    slug: 'nantuan-chengyuan-jiuba',
  },
];

export const dailyContest = [
  {
    id: 9,
    title: '今日最劲爆：某知名导演潜规则女演员录音曝光',
    hotLevel: '爆',
    date: '2026-07-07',
    image: 'https://readdy.ai/api/search-image?query=Film%20director%20chair%20on%20dark%20soundstage%2C%20dramatic%20spotlight%2C%20mysterious%20cinematic%20atmosphere%2C%20dark%20background%2C%20warm%20amber%20lighting%2C%20tense%20mood&width=600&height=400&seq=daily-01&orientation=landscape',
    slug: 'zhiming-daoyan-qian-guize',
  },
  {
    id: 10,
    title: '热搜第一：某女团成员被爆与经纪人有不正当关系',
    hotLevel: '热',
    date: '2026-07-07',
    image: 'https://readdy.ai/api/search-image?query=Kpop%20style%20stage%20with%20dark%20dramatic%20lighting%2C%20silhouettes%20of%20performers%2C%20mysterious%20backstage%20atmosphere%2C%20cinematic%2C%20dark%20background%20with%20warm%20glow&width=600&height=400&seq=daily-02&orientation=landscape',
    slug: 'nvtuan-chengyuan-jingjiren',
  },
  {
    id: 11,
    title: '疯狂刷屏：某说唱歌手吸毒实锤视频全网疯传',
    hotLevel: '爆',
    date: '2026-07-06',
    image: 'https://readdy.ai/api/search-image?query=Dark%20studio%20with%20microphone%20and%20dramatic%20red%20accent%20lighting%2C%20hip%20hop%20atmosphere%2C%20mysterious%20vibe%2C%20cinematic%20noir%20style%2C%20tense%20mood&width=600&height=400&seq=daily-03&orientation=landscape',
    slug: 'shuochang-geshou-xidu-shichui',
  },
];

export const featureNavItems = [
  {
    title: '网红黑料追踪',
    description: '全方位追踪网红达人最新动态，第一时间曝光不为人知的黑料内幕，让你吃瓜永远快人一步。',
    image: 'https://readdy.ai/api/search-image?query=Smartphone%20screen%20displaying%20social%20media%20feed%20on%20dark%20background%2C%20dramatic%20lighting%2C%20mysterious%20digital%20atmosphere%2C%20cinematic%2C%20warm%20dark%20tones&width=700&height=450&seq=feature-nav-01&orientation=landscape',
    href: '/category/wanghong',
  },
  {
    title: '明星塌房实录',
    description: '聚焦娱乐圈明星塌房事件，深扒内幕真相，记录每一个从神坛跌落的震撼瞬间。',
    image: 'https://readdy.ai/api/search-image?query=Falling%20star%20metaphor%20on%20dark%20background%2C%20dramatic%20lighting%2C%20cinematic%20mood%2C%20mysterious%20atmosphere%2C%20warm%20amber%20tones%2C%20artistic%20composition&width=500&height=350&seq=feature-nav-02&orientation=landscape',
    href: '/category/mingxing',
  },
  {
    title: '每日大赛不打烊',
    description: '每日更新最热门爆料大赛，实时追踪网络热议事件，让你永远不错过任何一个大瓜。',
    image: 'https://readdy.ai/api/search-image?query=Countdown%20clock%20on%20dark%20background%20with%20dramatic%20glow%2C%20urgent%20newsroom%20vibe%2C%20cinematic%20lighting%2C%20warm%20dark%20tones%2C%20tense%20atmosphere&width=500&height=350&seq=feature-nav-03&orientation=landscape',
    href: '/category/dasai',
  },
];

export const footerLinks = [
  {
    title: '热门分类',
    links: [
      { label: '网红黑料', href: '/category/wanghong' },
      { label: '明星塌房', href: '/category/mingxing' },
      { label: '每日大赛', href: '/category/dasai' },
      { label: '吃瓜视频', href: '/category/video' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '品牌介绍', href: '/about' },
      { label: '用户口碑', href: '/about' },
      { label: '投稿指南', href: '/about' },
      { label: '联系我们', href: '/about' },
    ],
  },
  {
    title: '帮助中心',
    links: [
      { label: '爆料须知', href: '/about' },
      { label: '隐私政策', href: '/about' },
      { label: '免责声明', href: '/about' },
      { label: '用户协议', href: '/about' },
    ],
  },
  {
    title: '关注我们',
    links: [
      { label: '微博', href: '#' },
      { label: '微信公众号', href: '#' },
      { label: '抖音', href: '#' },
      { label: '小红书', href: '#' },
    ],
  },
];

export const brandStats = {
  totalArticles: '128,560',
  dailyActive: '380,000',
  monthlyViews: '2.8亿',
  whistleblowers: '96,800',
};